import { render } from "./InternationalKeyWorldTradeIndicator.vue?vue&type=template&id=6140b638&scoped=true"
import script from "./InternationalKeyWorldTradeIndicator.vue?vue&type=script&lang=js"
export * from "./InternationalKeyWorldTradeIndicator.vue?vue&type=script&lang=js"

import "./InternationalKeyWorldTradeIndicator.vue?vue&type=style&index=0&id=6140b638&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6140b638"]])

export default __exports__